import React, {Component} from "react";
import _ from 'lodash';

class Updates extends Component {

    hideUpdates = () => {
        this.props.hideUpdates();
    }
    
    render() {
        const {showUpdates} = this.props;
        
        return (
            showUpdates ? 
            <div class="updates">
                <div class="hide-scores" onClick={this.hideUpdates}><i class="fas fa-times"></i></div>
                <h2><i class="far fa-calendar-alt"></i> Planned Features</h2>
                <section class="update">
                    <ul>
                        <li>Game state saving when closing, so you can continue from where you left off on returning.</li>
                        <li>Much later on: 4 and 6 word puzzles, potentially different themed event games (such as animal names, countries, etc...).</li>
                        <li>Potential future feature: round based multiplayer against your friends.</li>
                    </ul>
                </section>
                <h2><i class="fas fa-bullhorn"></i> Updates</h2>
                <section class="update">
                    <h3>03/02/2022 - Bug Fix and Light Default Theme</h3>
                    <ul>
                        <li>Fixed a bug where the first letter of 2 would be marked as green but the second wouldn't, meaning if you guessed 2 of the letters of the word, one was correct and one was incorrectly positioned it wouldn't show the second marked as "present".</li>
                        <li>Added a free light version of the default theme, to account for people who don't like dark themes.</li>
                    </ul>
                </section>
                <section class="update">
                    <h3>02/02/2022 - Discord and Desktop</h3>
                    <ul>
                        <li>
                            We have a discord now! Join by clicking the discord icon to the left of the updates button or click the link below:<br/>
                            <a href="https://discord.gg/rBt3ngW6Bz" rel="noreferrer" target="_blank"><i class="fab fa-discord" aria-hidden="true"></i> Join our discord!</a>
                        </li>
                        <li>Improved desktop/tablet experience and letter tiles are now square, rather than rectangles.</li>
                        <li>Coming soon: discord integration, allowing you to save you scores so you can access them on other devices, global leaderboards for weekly / monthly scores and eventually multiplayer.</li>
                    </ul>
                </section>
                <section class="update">
                    <h3>30/01/2022 - More Themes!</h3>
                    <p>2 more colour themes have been added, Luna and Ogre, I'll let you decide what these colours might be inspired by.</p>
                    <img src="https://i.gyazo.com/b351805d44e4593749a52740e5cb5f67.png" alt="2 new themes"/>
                </section>
                <section class="update">
                    <h3>29/01/2022 - Themes</h3>
                    <p>We've hit over 100 daily players! Thankyou for playing, and I hope you enjoy all our future updates 😁.</p>
                    <p>You can now spend your points on new themes to customise the look and style of your game, more themes with animated variants are yet to come.</p>
                    <video alt="Video from Gyazo" width="100%" autoplay muted loop playsinline controls><source src="https://i.gyazo.com/0d133adf546d235f1dd72dbfb4983bcc.mp4" type="video/mp4" /></video>
                </section>
                <section class="update">
                    <h3>28/01/2022 - Share</h3>
                    <p>You can now share previous games and see more detail, such as a preview of your solution.</p>
                    <img src="https://i.gyazo.com/a8dd4541c6b2cba254bf4a4dbb2ffa9d.png" alt="previous game update"/>
                </section>
                <section class="update">
                    <h3>28/01/2022 - Bug Fix</h3>
                    <p>Fixed bug where tiles were highlighted orange, even though there was no duplicate letters in the word.</p>
                </section>
                <section class="update">
                    <h3>28/01/2022 - Points</h3>
                    <p>Added a points system to the game, earn more points by completeing words with the fewest amount of attempts.</p>
                    <p>You have been backdated points for any games you have already played 😉</p>
                </section>
                <section class="update">
                    <h3>27/01/2022 - Share</h3>
                    <p>Added ability to share the game you just played, to challenge your friends.</p>
                </section>
                <section class="update">
                    <h3>27/01/2022 - Quality of Life</h3>
                    <p>Mostly quality of life updates today, based on feedback and missing features.</p>
                    <ul>
                        <li>Improved game success screen, with option to share and start another word.</li>
                        <li>Thousands of words have been added to the word list to help with guessing, this should mean you are much less likely to be denied trying a word.</li>
                        <li>Attempt distribution table added to stats to better gauge your success.</li>
                        <li>Minor visual upgrades added to improve readability of text on tiles and keyboard.</li>
                        <li>Desktop keyboard support.</li>
                    </ul>
                </section>
                <section class="update">
                    <h3>26/01/2022 - First Update</h3>
                    <p>Help and updates buttons added, to keep you informed of any changes and new features added to Gummidge.</p>
                    <p>Hope you are all enjoying the game, good luck solving!</p>
                    <hr></hr>
                    <p>Currently supporting thousands of word puzzles, with new words being added every day.</p>
                    <h4>Future updates coming:</h4>
                    <ul>
                        <li>Desktop keyboard support.</li>
                        <li>More detailed stats, showing the distribution of attempts to success.</li>
                        <li>Ability to share the game you just played, to challenge your friends.</li>
                        <li>Ways to share previous games and seem more detail.</li>
                        <li>Improved game success screen, with option to share and start another word.</li>
                        <li>Game state saving when closing, so you can continue from where you left off on returning.</li>
                        <li>Much later on: 4 and 6 word puzzles.</li>
                        <li>Potential future feature: round based multiplayer against your friends.</li>
                    </ul>
                </section>
            </div>
            : <></>
        );
    }
}

export default Updates;